export enum AdditionalPracticeFormFieldEnum {
    NAME = 'practiceName',
    ADDRESS = 'practiceAddress',
    CITY = 'practiceCity',
    STATE = 'practiceState',
    ZIP_CODE = 'practiceZip',
    EMAIL = 'practiceEmail',
    TEL = 'practicePhone',
    WEBSITE = 'practiceWebsite',
    COMPANY_TYPE = 'companyType',
    DESCRIPTION = 'practiceDesc',
    LOGO = 'practiceLogo',
    PRACTICE_FRONT_URL = 'practiceFrontUrl',
    KIWI_HEALTH_WEBSITE = 'kiwihealthWebsite',
    SPECIALTY_LIST = 'specialtyList',
    CONDITION_TREATED_LIST = 'conditionTreatedList',
    IS_DEFAULT = 'isDefault',
    AS_MAILING = 'asMailing',
    NOT_PUBLISH = 'notPublish',
    ID = 'id',
    NOT_HAVE_NAME = 'notHaveName',
    NOT_HAVE_PHONE = 'notHavePhone',
    ADDRESS_PUBLIC_TYPE = 'publicType',
    TAX_ID_TYPE = 'taxIdType',
    TAX_ID = 'taxId',
    SETUPLAPOPTION = 'setUpLapOption',
    W9FORM = 'w9Form',
    VFD_PHONE_LINE = 'vfdPhoneLine',
    APPOINTMENT_INTEGRATION_URL = 'appointmentIntegrationUrl',
    AVA_AUTO_REPLY = 'avaAutoReply',
}
